module.exports = __webpack_public_path__ + "img/maxcdn.84906f59.svg";